import { XTOKENSECRET } from "@/constants/configurations";

export const generateXToken = async function(postData) {
  const secret = XTOKENSECRET;
  const encoder = new TextEncoder();
  const keyData = encoder.encode(secret);

  // Import key for HMAC-SHA1
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: "SHA-1" }, 
    false,
    ["sign"]
  );

  const message = encoder.encode(JSON.stringify(postData));

  // Create the signature
  const signature = await crypto.subtle.sign("HMAC", cryptoKey, message);

  // Convert ArrayBuffer → hex string
  return Array.from(new Uint8Array(signature))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("");
}
